import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Alert,
} from '@mui/material';
import { FC } from 'react';
import { Route } from '@helpers/types.ts';
import { useSplitRoute } from './use-split-route.ts';
import { VehiclesCapacities } from '@components/vehicle-capacities.tsx';
import { vehicles_joins } from '@helpers/constants.tsx';
import { LoadingButton } from '@mui/lab';
import { Error } from '@mui/icons-material';
import { IVehiclesCapacities } from '@helpers/types.ts';

interface ISplitRouteModalProps {
  planId: string;
  route: Route;
  onCancel: () => void;
  onSuccess: (routeId: string, vehicles: Partial<IVehiclesCapacities>) => void;
}

export const SplitRouteModal: FC<ISplitRouteModalProps> = (props) => {
  const {
    error,
    loading,
    vehicles,
    setLoading,
    totalVehicles,
    onChangeVehicles,
  } = useSplitRoute(props.route);
  return (
    <Dialog
      open={true}
      maxWidth={'xs'}
      fullWidth={true}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-description"
    >
      <DialogTitle id="alert-dialog">
        Indique el número de vehículos que desea usar al dividir esta zona
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
 <Grid component="div" size={{ xs: 12 }}>
          </Grid>
          <Grid component="div" size={{ xs: 12 }}>
            <VehiclesCapacities
              hideTitle={true}
              value={vehicles}
              vehicles={vehicles_joins}
              onChange={onChangeVehicles}
            />
          </Grid>

          {error && (
            <Grid component="div" size={{ xs: 12 }}>
              <Alert color="warning" icon={<Error />}>
                {error}
              </Alert>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disableElevation={true}
          onClick={props.onCancel}
        >
          Cancelar
        </Button>
        <LoadingButton
          autoFocus
          color="primary"
          variant="contained"
          disableElevation={true}
          loading={loading}
          disabled={!!error || totalVehicles <= 1}
          onClick={() => {
            setLoading(true);
            props.onSuccess(props.route.id, vehicles);
          }}
        >
          Aceptar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
